<template>
	<div class="togglebox-wrapper">
		<div
			class="togglebox"
			:class="{ 'less-padding': description, 'more-padding': !description }"
		>
			<div>
				<div class="title" v-text="title" />
				<div v-if="description" class="description" v-text="description" />
			</div>
			<ToggleSwitch
				v-model="checked"
				@change="$emit('checkedEvent', $event)"
				:loading="loading"
				:class="{ 'center-toggle': description }"
			/>
		</div>
		<SpinnerCheckmark class="success" :spinner="spinner" />
	</div>
</template>

<script>
import { ToggleSwitch } from '@/components/common'
import SpinnerCheckmark from '@/components/common/SpinnerCheckmark'

export default {
	props: ['title', 'description', 'toggleChecked', 'spinner', 'loading'],
	components: { ToggleSwitch, SpinnerCheckmark },
	data() {
		return { checked: this.toggleChecked }
	},
	emits: ['checkedEvent'],
	watch: {
		toggleChecked(newVal) {
			this.checked = newVal
		}
  },
}
</script>

<style lang="scss" scoped>
.togglebox-wrapper {
	position: relative;
}

.togglebox {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-left: 25px;
	padding-right: 15px;
	border-radius: 4px;
	border: solid 1px var(--neutral-40040);
	.pronto-toggle {
		font-size: 24px;
	}
}

.title {
	font-family: Avenir-Medium;
	font-size: 16px;
}

.description {
	font-family: Avenir-Medium;
	font-size: 14px;
	color: var(--neutral-500);
	margin-top: 10px;
	margin-right: 5px;
	padding-bottom: 4px;
}

.less-padding {
	padding-top: 4px;
}

.more-padding {
	padding-top: 15px;
	padding-bottom: 15px;
}

.center-toggle {
	margin-top: 14px;
}

.success {
	position: absolute;
	top: 12px;
	right: -2px;
}
</style>
